import { ComponentRenderHooks, ListItemsHooks } from "@launchos/plugins/types";
import LivePopup from "./component";

export const onComponentRender = (hook, payload, actions) => {
  if (hook.id === ComponentRenderHooks.WEBCOMPONENT && payload.type === "Popup") {
    return [LivePopup];
  }
};
